import { render, staticRenderFns } from "./deposit-detail.vue?vue&type=template&id=81c9a9d4&"
import script from "./deposit-detail.vue?vue&type=script&lang=js&"
export * from "./deposit-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports